import React, { FC } from 'react'

const MIRIcon: FC = () => (
  <svg width="24" height="7" viewBox="0 0 24 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6861 0H16.9365C17.1739 1.29345 18.1439 2.33177 19.3988 2.66996C19.6836 2.7471 19.9832 2.78863 20.2918 2.78863H23.9526C23.9852 2.63436 24.0001 2.47713 24.0001 2.31397C24.0001 1.03535 22.9647 0 21.6861 0Z"
      fill="#ADB0CC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2363 3.08508V6.79336H19.3723V4.62773H21.6863C22.6949 4.62773 23.5493 3.98397 23.8667 3.08508H17.2363Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2696 0C14.2696 0 13.6436 0.0563658 13.3499 0.71199L11.8369 4.03461H11.6589V0H9.52295V6.79357H11.5403C11.5403 6.79357 12.1959 6.73424 12.4896 6.08158L13.9729 2.75896H14.1509V6.79357H16.2869V0H14.2696Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.46724 1.29256e-07V0.00296675C6.46428 0.00296675 5.52979 1.19209e-07 5.28059 0.892954C5.05216 1.71174 4.40841 3.97231 4.39061 4.03461H4.21261C4.21261 4.03461 3.55402 1.72361 3.32262 0.889988C3.07342 -0.00296652 2.13597 1.29256e-07 2.13597 1.29256e-07H0V6.79357H2.13597V2.75896H2.31397L3.55995 6.79357H5.04326L6.28925 2.76193H6.46724V6.79357H8.60321V1.29256e-07H6.46724Z"
      fill="#747796"
    />
  </svg>
)

export default MIRIcon
